import { ApplicationInsights } from '@microsoft/applicationinsights-web'
import { ReactPlugin } from '@microsoft/applicationinsights-react-js'

const reactPlugin = new ReactPlugin()
let appInsights = null

const connectionString = import.meta.env.VITE_APPINSIGHTS_CONNECTION_STRING

if (connectionString) {
    appInsights = new ApplicationInsights({
        config: {
            connectionString,
            extensions: [reactPlugin],
            enableAutoRouteTracking: true,
            enableCorsCorrelation: true,
            correlationHeaderDomains: ['po-processor-app.atlanticpkg.com'],
            enableUnhandledPromiseRejectionTracking: true,
            disableFetchTracking: false,
        }
    })
    appInsights.loadAppInsights()
}

export { appInsights, reactPlugin }

/**
 * Track a custom event in Application Insights.
 * No-ops gracefully when telemetry is disabled (no connection string).
 */
export function trackEvent(name, properties = {}) {
    appInsights?.trackEvent({ name }, properties)
}

/**
 * Track an exception in Application Insights.
 * No-ops gracefully when telemetry is disabled.
 */
export function trackError(error, properties = {}) {
    appInsights?.trackException({ exception: error }, properties)
}
